export const GET_CONTACTS = "GET_CONTACTS";
export const GET_CONTACTS_SUCCESS = "GET_CONTACTS_SUCCESS";
export const GET_CONTACTS_FAILURE = "GET_CONTACTS_FAILURE";

export const GET_SINGLE_CONTACT = "GET_SINGLE_CONTACT";
export const GET_SINGLE_CONTACT_SUCCESS = "GET_SINGLE_CONTACT_SUCCESS";
export const GET_SINGLE_CONTACT_FAILURE = "GET_SINGLE_CONTACT_FAILURE";

export const DELETE_CONTACT = "DELETE_CONTACT";
export const DELETE_CONTACT_SUCCESS = "DELETE_CONTACT_SUCCESS";
export const DELETE_CONTACT_FAILURE = "DELETE_CONTACT_FAILURE";
